import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { cn } from '@/lib/cn';

/** מסך פנימי: חזרה (שברון שמצביע ימינה ב RTL), כותרת, ותת כותרת אפורה. */
export function SubBar({
  title,
  subtitle,
  className,
}: {
  title: string;
  subtitle?: string;
  className?: string;
}) {
  const navigate = useNavigate();

  return (
    <header
      className={cn(
        'sticky top-0 z-20 flex min-h-16 items-center gap-2 border-b border-line bg-surface px-4',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => navigate(-1)}
        aria-label="חזרה"
        className="inline-flex min-h-11 min-w-11 cursor-pointer items-center justify-center bg-transparent"
      >
        <ChevronRight size={24} strokeWidth={1.75} aria-hidden="true" />
      </button>
      <div className="grid">
        <h1 className="m-0 font-display text-display-m font-semibold">{title}</h1>
        {subtitle && <p className="m-0 text-body-sm text-muted">{subtitle}</p>}
      </div>
    </header>
  );
}
